import { Accounts, Notifications, Profile, Security } from '@/views/Profile'

const ProfilePage: React.FC = () => {
  return (
    <div>
      <Profile />
      <Accounts />
      <Notifications />
      <Security />
    </div>
  )
}

export default ProfilePage
